import type { DataJson } from '../types';
import { read_json_body, http_error_message } from '../utils/http';

/**
 * Fetches the logged-in client's project data from the API.
 * The response mirrors the historical data.json root shape.
 *
 * @param token - JWT of the logged-in user
 * @param projectId - Required when the token belongs to an admin (preview mode)
 */
export const fetchProjectData = async (
  token: string,
  projectId?: string
): Promise<DataJson> => {
  const url = projectId
    ? `/api/project-data?project_id=${encodeURIComponent(projectId)}`
    : '/api/project-data';

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await read_json_body<DataJson & { error?: string }>(response);

  if (!response.ok || !data) {
    const message = data?.error || http_error_message(response, data !== null);
    const error = new Error(message) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }

  return data as DataJson;
};
